export default __webpack_public_path__ + "static/media/120.ceb17da0.jpg";